/*
  src/redux/errors/constants.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'errors', action].join('/');
}

export const ERROR_DISMISSED = createConstant('ERROR_DISMISSED');



// WEBPACK FOOTER //
// ./src/shared/redux/errors/constants.js